import 'focus-visible'

import App from 'layouts/App'
import React from 'react'
import ReactDOM from 'react-dom'
import { startTraceMark } from 'utils/trace'

import * as serviceWorker from '../../serviceWorker'

import '../../index.css'

startTraceMark('widget_core:widget_loaded')

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorker.unregister()
